import { render, staticRenderFns } from "./studentTrainForm.vue?vue&type=template&id=baf9bde8"
import script from "./studentTrainForm.vue?vue&type=script&lang=js"
export * from "./studentTrainForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports